import React from "react";
import PropTypes from "kf-proptypes/widgets";

import { Button, BUTTON_SIZES } from "../../inputs/button/index.jsx";
import { OverflowText } from "@widgets/datadisplay/index.jsx";

import styles from "./styles.css";

export const BottomToast = ({
  content,
  onActionClick,
  leftIcon,
  buttonLeftIcon,
  buttonContent,
  className = ""
}) => {
  return (
    <div
      className={`${styles.bottomToastContainer} ${className} ${
        leftIcon ? styles.hasLeftIcon : ""
      }`}
    >
      {leftIcon}
      <OverflowText className="base400">{content}</OverflowText>
      <Button
        onClick={onActionClick}
        leftIcon={buttonLeftIcon}
        size={BUTTON_SIZES.SMALL_DEPRECATED}
      >
        {buttonContent}
      </Button>
    </div>
  );
};

BottomToast.propTypes = {
  /**
   * toast content to display for user
   */
  content: PropTypes.string.isRequired,
  /**
   * a function which will do some action based on requirement
   */
  onActionClick: PropTypes.func.isRequired,
  /**
   * action button content
   */
  buttonContent: PropTypes.node.isRequired,
  /**
   * Toast button left icon inside button
   */
  buttonLeftIcon: PropTypes.node,
  className: PropTypes.string,
  /**
   * Left Icon for bottomtoast
   */
  leftIcon: PropTypes.node
};
